<template>
  <nav>
    <div class="fill-height">
      <v-row
        class="fill-height"
        align="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          offset-sm="2"
          offset-md="3"
          align="center"
        >
          <p class="text-h1 font-weight-bold">
            {{ $t('403') }}
          </p>
          <p class="text-h4 font-weight-bold">
            {{ $t('pageAccessDeniedTitle') }}
          </p>
          <p class="text-body-1 greytext--text d-none d-sm-block">
            {{ $t('pageAccessDeniedText') }}
          </p>
          <v-btn
            data-testid="go-back-to-home-button"
            color="accent"
            large
            class="rounded-xxl text-none mt-10 px-10"
            rounded
            elevation="0"
            @click="exitPageAccessDenied"
          >
            {{ $t('goBackToHome') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </nav>
</template>

<script>
export default {
    name:'PageAccessDenied',
    data(){
        return{
            roleInSpace: localStorage.space ? JSON.parse(localStorage.space).role : null,
        }
    },
    methods: {
        exitPageAccessDenied() {
            var space = window.location.host.split('.')[0];
            if (this.roleInSpace == 'participant' || this.roleInSpace == 'guest') {
                if(space == 'id'){
                  this.$router.push({path: '/spaces'})
                } else {
                  this.$router.push({path: '/dashboard-participant'})
                }
            } else {
                if (space == 'id') {
                  this.$router.push({path: '/spaces'})
                } else {
                  this.$router.push({path: '/dashboard'})
                }
            }
        },
    }
}
</script>
